'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isNextMonth = {};

exports.__exports = isNextMonth;
